import { CarouselController } from "./carousel_controller"

export default class extends CarouselController {
}
